/**
 * Enum for value types.
 *
 * @export
 * @enum {number}
 */
export enum ValueType {
  // string
  String= "string",
  // number
  Number= "number",
  // date
  Date= "date",
  // boolean
  Boolean= "boolean",
  // array
  Array= "array",
  // object
  Object= "object",
  // regexp
  RegExp= "regexp", 
}